import { render } from "./VersionCheckToast.vue?vue&type=template&id=6e69b1d6"
import script from "./VersionCheckToast.vue?vue&type=script&lang=js"
export * from "./VersionCheckToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__